// The barcode reader for the ops phone. The loader itself is shared with the partner link
// (`@ecobox/ui/detector`); this file only says where this app serves the WebAssembly file from.
import { createDetectorKit } from '@ecobox/ui/detector';
import zxingWasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';

export const { loadPolyfillDetector, loadBarcodeDetector, warmUpScanner } = createDetectorKit({
  wasmUrl: zxingWasmUrl,
});
